import { ScheduleDisplayModelFormGroup, AnfrageDisplayModel, ScheduleDisplayModel, MilestoneDisplayModelFormGroup } from '@/api/model-index';
import { AnfrageService } from '@/api/service-index';
import { AnfrageNavigationFormComponent, MoveDirection } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { StateService } from '@/core/services/state.service';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { convertJSDateString } from '@/core/utils/date-converter';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridDataResult } from '@progress/kendo-angular-grid';

@Component({
  selector: 'schedule-data-process-step',
  templateUrl: './schedule-data-process-step.component.html',
  styleUrls: ['./schedule-data-process-step.component.scss']
})
export class ScheduleDataProcessStepComponent extends AnfrageNavigationFormComponent {
  public scheduleDataProcessStepForm: ScheduleDisplayModelFormGroup;
  public anfrage: AnfrageDisplayModel;
  public scheduleData: ScheduleDisplayModel;
  public gridView: GridDataResult; 
  public reportId: string;

  public saveEvent(): void {
    this.save(true, MoveDirection.STAY);
  }

  public get formGroup(): FormGroup<any> {
    return this.scheduleDataProcessStepForm;
  }
  
  constructor(
    protected sectionService: SectionService,
    protected route: ActivatedRoute,
    protected loadingAnimationService: LoadingAnimationService,
    protected router: Router,
    protected stateService: StateService,
    protected anfrageService: AnfrageService,
    protected portalContextService: PortalContextService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService
  ) {
    super(sectionService, router, route, portalContextService);
    this.scheduleDataProcessStepForm = ScheduleDisplayModelFormGroup.Instance;
    this.anfrage = this.route.snapshot.data.anfrage;
    
    this.reportId = <string>this.route.snapshot.paramMap.get('reportid');
    this.initializeMilestones();
    
    this.router.events.subscribe(route => {
      this.reportId = <string>this.route.snapshot.paramMap.get('reportid');
    })
  }

  protected initializeMilestones() {
    this.scheduleDataProcessStepForm.Milestones.clear();

    this.scheduleData = this.route.snapshot.data.scheduleData;
    this.scheduleDataProcessStepForm.patchValue(this.scheduleData);

    this.scheduleData.milestones?.forEach(element => {
      let tmpMilestone = MilestoneDisplayModelFormGroup.Instance;
      tmpMilestone.patchValue(element);
      this.scheduleDataProcessStepForm.Milestones.push(tmpMilestone);
    });

    this.gridView = {
      data:  this.scheduleDataProcessStepForm.Milestones.value,
      total: this.scheduleDataProcessStepForm.Milestones.value.length,
    };
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    if (shouldSave && this.scheduleDataProcessStepForm.dirty && this.scheduleDataProcessStepForm.valid) {
      delete this.portalContextService.CurrentAnfrage.schedule;
      this.scheduleDataProcessStepForm.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }

      this.scheduleDataProcessStepForm.Milestones.controls.map((control : any) => {
        control.DatumPlan.patchValue(convertJSDateString(control.DatumPlan.value));
        control.DatumIst.patchValue(convertJSDateString(control.DatumIst.value));
      })

      let subscription = this.anfrageService.apiAnfrageAnfrageIdSchedulePatch({ anfrageId: this.anfrage.id, reportId: this.reportId, body: this.scheduleDataProcessStepForm.value })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdScheduleGet({ anfrageId: this.anfrage.id, reportId: this.reportId }).subscribe(response => {
            if (response) {
              this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id, reportId: this.reportId }).subscribe(result => {
                this.stateService.ValidationErrors = result;
              })

              if (this.portalContextService.CurrentAnfrage)
                this.portalContextService.CurrentAnfrage.schedule = response;

              this.scheduleDataProcessStepForm.patchValue(response);

              this.scheduleDataProcessStepForm.markAsPristine();
            }
          });
        });

        this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
        this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.scheduleDataProcessStepForm.markAsPristine();
      this.move(moveDirection);
    }
  }
}
